import { render, staticRenderFns } from "./companyFooterInfo.vue?vue&type=template&id=72e973a3"
import script from "./companyFooterInfo.vue?vue&type=script&lang=js"
export * from "./companyFooterInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports